export enum ToastType {
  ERROR_UNAVAILABLE_COUPON = 'ERROR_UNAVAILABLE_COUPON',
  ERROR_GENERAL = 'ERROR_GENERAL',
  NONE = '',
}
